import styled from 'styled-components'

export const Bookmark = styled.div`
  margin-top: -3rem;
  padding-bottom: 3rem;
  position: relative;
  z-index: -1;
  height: 0;
`
